import React from "react";
import { motion } from "framer-motion";
import { INTEGRATIONS_ALL } from "../lib/content";

export default function HowItWorks() {
  const steps = [
    {
      n: "01",
      title: "Connect",
      body:
        "Connect in 8 minutes. Standard integrations. No custom dev. We read what you already have.",
    },
    {
      n: "02",
      title: "Watch",
      body:
        "Every 60 seconds we scan what's changed. New lead? Stale estimate? Renewal coming up? We see it.",
    },
    {
      n: "03",
      title: "Draft",
      body:
        "We write the reply. You read it. You hit send. We never message your customers. Ever.",
    },
  ];

  return (
    <section
      id="how"
      data-testid="how-it-works-section"
      className="bg-[#FAF7F2] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <p className="kicker">How it works</p>
            <h2 className="h-section text-[clamp(2rem,4vw,3.4rem)] mt-5 max-w-3xl">
              We sit above your stack.
              <span className="text-[#4A4A4A]"> We don't replace it.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="font-serif-body text-[1.05rem] text-[#4A4A4A] leading-relaxed">
              You already pay for the software you need. We work the keyboard
              you already pay for. No new dashboard to babysit.
            </p>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-10">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="relative"
              data-testid={`how-step-${i + 1}`}
            >
              <p className="font-mono-spec text-[12px] tracking-[.18em] text-[#E07B3A]">
                STEP {s.n}
              </p>
              <h3 className="h-card text-[clamp(1.4rem,2.4vw,2rem)] mt-3">
                {s.title}
              </h3>
              <p className="font-serif-body text-[#4A4A4A] mt-3 text-[1.02rem] leading-relaxed">
                {s.body}
              </p>
            </motion.div>
          ))}
        </div>

        <div className="mt-20">
          <p className="kicker text-[#4A4A4A]">Real integrations</p>
          <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
            {INTEGRATIONS_ALL.map((name) => (
              <div
                key={name}
                className="logo-cell"
                data-testid={`integration-${name.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <span className="dot" />
                <span className="text-[#1A1A1A]">{name}</span>
              </div>
            ))}
          </div>
          <p className="font-serif-body text-[#4A4A4A] mt-6 text-[15px]">
            Not on the list? Tell us. We add one new connector every two weeks.
          </p>
        </div>
      </div>
    </section>
  );
}
